<template>
  <!--页面加载动画-->
  <div>
  <div class="items-wrap">
    <span class="lables">
      {{selectData.elementName}}
      <i class="iconfont iconyiwenhao" @click="showNames=true"></i>
      </span>
    <div class="from-right">
      <input
        type="number"
        class="input-text"
        :value="defaultTxt"
        @blur="handle"
        :placeholder="selectData.elementDescribe"
      />
      <i class="iconfont iconfabiaowenzhang"></i>
    </div>
  </div>
  <p v-if="status" class="bank-info">{{status}}</p>
  <van-action-sheet v-model="showNames" title="本产品支持银行">
    <div class="bankname-box" v-if="selectData && selectData.elementItems">
      <div class="bankname-li" v-for="(item,i) in selectData.elementItems" :key="i">{{item.name}}</div>
    </div>
  </van-action-sheet>
  </div>
</template>

<script>
import insureJs from "@/logic/aboutInsure";
export default {
  data() {
    return {
      defaultTxt: "", //默认值
      bankName: "", //银行名称
      bankCode: "", //银行卡code
      status:'',//查询状态
      showNames:false,
    };
  },
  props: ["selectData"],
  mounted() {
    if (this.selectData.elementValue) {
      this.defaultTxt = this.selectData.elementValue.number;
      this.$store.commit('updateBankInfo', this.selectData.elementValue);
    }
  },
  methods: {
    bankNames(){
      let elementItems = this.selectData.elementItems;
      let bankNames="";
      elementItems.forEach((item,i)=>{
        bankNames+=i==0?item.name:"，"+item.name;
      })
      this.$notice.alert(`本产品支持的银行包括：${bankNames}。`)
    },
    handle(e) {
      //输入框失焦回调
      console.log(e.target.value);
      this.defaultTxt = e.target.value;
      if (insureJs.BankCheck(e.target.value)) {
        this.getBankInfo(e.target.value);
      } else {
        this.setError("您填写的银行卡号有误，请重新填写！");
      }
    },
    getBankInfo(num) {
      this.status="正在查询银行卡信息"
      this.$http({
        url: "/insure/getBankInfo",
        contentType: "from",
        data: {
          cardNumber: num
        }
      })
        .then(data => {
          console.log(data);
          if (data.data.binValidateMsg.cardType == "CC") {
            this.setError("检测到您填写的银行卡号是信用卡，请修改您的卡号");
          } else {
            let bankName = data.data.bankName;
            if(!bankName){
              this.setError(`未查询到相关银行信息`);
              return;
            }
            if (data.bankName == "广东发展银行") {
              bankName = "广发银行";
            } else if (data.bankName == "上海浦东发展银行") {
              bankName = "浦发银行";
            }
            const findBank = _.findIndex(this.selectData.elementItems, item => {
              return (
                item.name.indexOf(bankName) > -1 ||
                bankName.indexOf(item.name) > -1
              );
            });
            if (findBank < 0) {
              this.setError(`检测结果为：${bankName},暂不支持该银行投保`);
            } else {
              this.bankName = this.selectData.elementItems[findBank].name;
              this.bankCode = this.selectData.elementItems[findBank].value;
              this.setError();
              this.status=bankName
              this.getResult();
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.setError(`银行卡校验失败，失败原因：${err.msg}`);
        });
    },
    getResult() {
      //选择后回调到父组件
      let value = {
        number: this.defaultTxt,
        bankName: this.bankName,
        bankCode: this.bankCode
      };
      this.selectData.elementValue = value;
      this.$store.commit('updateBankInfo', value);
      this.$emit("selected", {
        type: 1,
        item: this.selectData,
        value: value
      });
    },
    setError(msg) {
      if (!msg) {
        return (this.selectData.errorMsg = "");
      }
      this.status=msg
      this.$notice.msg(msg);
      this.selectData.errorMsg = msg;
    }
  }
};
</script>

<style lang="scss" scoped>
.iconyiwenhao{
  color: #0084ff;
  font-size: 28px;
}

.bank-info{
    color: #ff7f27!important;
    font-size:28px!important;
    text-align: right;
  }

.defaultTxt {
  width: 100%;
  line-height: 40px;
  font-size: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 50px;
  display: inline-block;
}
.bankname-box{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-bottom: 15px;
  padding: 0 20px 15px;
  .bankname-li{
    width: 50%;
    text-align: center;
    line-height: 1.5;
    padding: 10px;
  }
}
</style>
